<div class="insight-container {{ insightColor }}-container">
    <img
        class="insight-icon"
        src="assets/img/{{ insightColor }}-warning-icon.svg"
        alt="warning icon"
    />
    <div class="insight-body">
        <h1 class="insight-title">{{ insightTitle }}</h1>

        <p class="insight-description">
            {{ insightInfo }}
        </p>
    </div>
</div>
